/**
 * Compares 2 dates checking if they represent same day
 * @param  {Date}    a
 * @param  {Date}    b
 * @return {boolean}   True if same, if any is not defined then false
 */
export function isSameDay(a: Date | undefined, b: Date | undefined): boolean {
    return !!(
        a &&
        b &&
        a.getUTCFullYear() === b.getUTCFullYear() &&
        a.getUTCDate() === b.getUTCDate() &&
        a.getUTCMonth() === b.getUTCMonth()
    );
}
